// extracted by mini-css-extract-plugin
export default {"wrapper":"logo__wrapper__loI82","hacksterLogo":"logo__hacksterLogo__TqXxI","presentSvg":"logo__presentSvg__Rk1tE"};